"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ModalMessageDirective = /** @class */ (function () {
    function ModalMessageDirective(modal) {
        return {
            restrict: 'A',
            scope: {
                templateUrl: '@',
                modalSize: '@',
                modalOnAccept: '&',
                modalMessageText: '@'
            },
            link: function (scope, element) {
                scope.templateUrl = scope.templateUrl;
                element.click(function () {
                    modal.show(scope.templateUrl, {
                        modalMessageText: scope.modalMessageText
                    }, function (result) {
                        if (typeof scope.modalOnAccept === 'function') {
                            var callbackResult = scope.modalOnAccept.call(result);
                            // Check for wrapper function syntax
                            if (typeof callbackResult === 'function') {
                                callbackResult(result);
                                // [2016-02-29] possible breakpoint
                            }
                            else if (typeof callbackResult === 'string') {
                                window.location.href = callbackResult;
                            }
                        }
                        else if (typeof scope.modalOnAccept === 'string') {
                            window.location.href = scope.modalOnAccept;
                        }
                        return;
                    });
                });
            }
        };
    }
    ModalMessageDirective.create = function (modal) {
        return new ModalMessageDirective(modal);
    };
    return ModalMessageDirective;
}());
exports.ModalMessageDirective = ModalMessageDirective;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibW9kYWxNZXNzYWdlLmRpcmVjdGl2ZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm1vZGFsTWVzc2FnZS5kaXJlY3RpdmUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQTtJQUNJLCtCQUFZLEtBQUs7UUFDYixPQUFPO1lBQ0gsUUFBUSxFQUFFLEdBQUc7WUFDYixLQUFLLEVBQUU7Z0JBQ0gsV0FBVyxFQUFFLEdBQUc7Z0JBQ2hCLFNBQVMsRUFBRSxHQUFHO2dCQUNkLGFBQWEsRUFBRSxHQUFHO2dCQUNsQixnQkFBZ0IsRUFBRSxHQUFHO2FBQ3hCO1lBQ0QsSUFBSSxFQUFFLFVBQUMsS0FBSyxFQUFFLE9BQU87Z0JBQ2pCLEtBQUssQ0FBQyxXQUFXLEdBQUcsS0FBSyxDQUFDLFdBQVcsQ0FBQztnQkFDdEMsT0FBTyxDQUFDLEtBQUssQ0FBQztvQkFDVixLQUFLLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxXQUFXLEVBQUU7d0JBQzFCLGdCQUFnQixFQUFFLEtBQUssQ0FBQyxnQkFBZ0I7cUJBQzNDLEVBQUUsVUFBQyxNQUFXO3dCQUNYLElBQUksT0FBTyxLQUFLLENBQUMsYUFBYSxLQUFLLFVBQVUsRUFBRTs0QkFDM0MsSUFBSSxjQUFjLEdBQUcsS0FBSyxDQUFDLGFBQWEsQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDLENBQUM7NEJBQ3RELG9DQUFvQzs0QkFDcEMsSUFBSSxPQUFPLGNBQWMsS0FBSyxVQUFVLEVBQUU7Z0NBQ3RDLGNBQWMsQ0FBQyxNQUFNLENBQUMsQ0FBQztnQ0FDdkIsbUNBQW1DOzZCQUN0QztpQ0FBTSxJQUFJLE9BQU8sY0FBYyxLQUFLLFFBQVEsRUFBRTtnQ0FDM0MsTUFBTSxDQUFDLFFBQVEsQ0FBQyxJQUFJLEdBQUcsY0FBYyxDQUFDOzZCQUN6Qzt5QkFFSjs2QkFBTSxJQUFJLE9BQU8sS0FBSyxDQUFDLGFBQWEsS0FBSyxRQUFRLEVBQUU7NEJBQ2hELE1BQU0sQ0FBQyxRQUFRLENBQUMsSUFBSSxHQUFHLEtBQUssQ0FBQyxhQUFhLENBQUM7eUJBQzlDO3dCQUVELE9BQU87b0JBQ1gsQ0FBQyxDQUFDLENBQUM7Z0JBQ1AsQ0FBQyxDQUFDLENBQUM7WUFDUCxDQUFDO1NBQ0osQ0FBQTtJQUNMLENBQUM7SUFFTSw0QkFBTSxHQUFiLFVBQWMsS0FBSztRQUNmLE9BQU8sSUFBSSxxQkFBcUIsQ0FBQyxLQUFLLENBQUMsQ0FBQztJQUM1QyxDQUFDO0lBQ0wsNEJBQUM7QUFBRCxDQUFDLEFBeENELElBd0NDO0FBeENZLHNEQUFxQiJ9